import React from 'react';
import './App.css';
import Shop from './Components/Shop/Shop';
import Header from './Components/Header/Header';



function App() {

  

  return (
    <div className="App">
      <Header></Header>
      <Shop></Shop>
      
    </div>
  );
}

export default App;
